var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._g(_vm._b({attrs:{"append-icon":_vm.mdiChevronDown,"items":_vm.Years},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'v-autocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }